import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  orderSummaryWrapper: {
    padding: theme.spacing(11, 15),
    boxShadow: '0px 4px 4px #00000005',
    borderRadius: theme.spacing(10),
    background: `${theme.palette.background.paper} 0% 0% no-repeat padding-box`,
    paddingRight: 121,
  },
  orderSummaryTop: {
    padding: theme.spacing(6, 0),
    marginBottom: theme.spacing(7.5),
  },
  orderSummarySubtitle: {
    color: theme.palette.grey.A100,
    padding: '0px 40px ',
  },
  controlsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '30%',
    minWidth: 400,
  },
  datePickerContainer: {
    minWidth: 160,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
}));
